<div class="overflow-auto p-5" style="height: 75vh">
  <div class="flex flex-col w-full" *ngIf="queueDevices.length > 0">
    <div class="inline-block min-w-full pb-2 align-middle">
      <table class="min-w-full">
        <thead class="border-b border-gray-400">
          <tr>
            <th scope="col" class="px-2 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
              Nome
            </th>
            <th scope="col" class="px-2 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
              Tipos de dispositivo
            </th>
            <th scope="col" class="px-2 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
              Empresa
            </th>
            <th scope="col" class="px-2 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
              Responsável
            </th>
            <th
              scope="col"
              class="px-2 py-3 font-bold tracking-wider text-center uppercase text-chathams-blue"
              *isAllowed="[ERoleAdminString.Admin, 'device.edit']"
            >
              Mais
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-white hover:bg-iceberg" *ngFor="let device of queueDevices">
            <td class="px-3 py-4 pl-0 font-medium text-md text-chathams-blue whitespace-nowrap">
              {{ device.name }}
            </td>
            <td class="px-3 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
              {{ device.deviceTypeName }}
            </td>
            <td class="px-3 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
              {{ device.companyName }}
            </td>
            <td class="px-3 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
              {{ device.contactName }} <br />
              {{ device.contactPhone }}
            </td>
            <td class="flex justify-center flex-1 gap-2 px-6 py-4 whitespace-normal text-md text-chathams-blue">
              <button
                *isAllowed="[ERoleAdminString.Admin, 'device.edit']"
                class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                (click)="abrirEmNovaAba(device.id!)"
                title="Editar Dispositivo"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#000000"
                  width="20"
                  height="20"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </button>

              <button
                *isAllowed="[ERoleAdminString.Admin, 'queue.edit']"
                (click)="removeDevice(device.id)"
                title="Remover dispositivo"
                class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
              >
                X
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex justify-end mb-5">
      <app-paginacao
        [numeroDeItens]="dadosPaginacaoDevices.itensTotal"
        [tamanhoDaPagina]="dadosPaginacaoDevices.tamanhoPagina"
        [paginaSelecionada]="dadosPaginacaoDevices.paginaSelecionada"
        [totalPage]="dadosPaginacaoDevices.totalPaginas"
        [opcaoItensPagina]="[4, 8]"
        (mudouPagina)="mudouPagina.emit($event)"
        (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
      ></app-paginacao>
    </div>
  </div>

  <div>
    <div class="flex items-center justify-center m-4">
      <button *ngIf="!addDeviceOpen" class="w-80 btn btn--secondary mr-5" (click)="addDeviceOpen = true">
        Adicionar dispositivo
      </button>
    </div>
  </div>

  <form *ngIf="addDeviceOpen" (ngSubmit)="addDevices()" [formGroup]="formGroup">
    <ng-select
      notFoundText="Nenhum item encontrado"
      [items]="deviceOptions"
      placeholder="Dispositivos"
      formControlName="devicesSelected"
      bindLabel="name"
      bindValue="id"
      [multiple]="true"
    >
    </ng-select>

    <div class="flex items-center justify-center m-4">
      <button class="w-80 btn btn--secondary mr-5" type="submit">Adicionar dispositivo</button>
    </div>
  </form>
</div>
